import React, { useMemo, useState } from 'react';
import { Typeahead } from '@pass-frontend/common/components/typeahead/ui';
import { TypeaheadPortal } from '@pass-frontend/common/components/typeahead/ui';
import { Geolocation } from '@pass-frontend/data-access/common/edge';

export interface LocationTypeaheadProps {
  onSelectAddress?: (addressOption) => void;
  onQueryChanged: (string) => void;
  data: { locationSuggestions: Geolocation[] };
  shouldShowErrorMessage?: boolean;
  setShouldShowErrorMessage?: (boolean) => void;
  usePortal?: boolean;
  // XXX these props are deprecated - existing uses are confused, thinking this holds a string, and setting address and inputvalue in tandem, instead of encapsulating inputValue
  inputValue?: unknown;
  setInputValue?: (unknown) => void;
  debouncingTime?: number;
}

export interface FormattedGeolocationForDropdown {
  value: Geolocation;
  label: string;
}

export const formatGeolocationForDropdown = (
  geolocationSugg: Geolocation,
): FormattedGeolocationForDropdown => {
  return {
    label: geolocationSugg.name,
    value: geolocationSugg,
  };
};

export function LocationTypeahead({
  onSelectAddress,
  data,
  onQueryChanged,
  shouldShowErrorMessage,
  setShouldShowErrorMessage,
  inputValue,
  setInputValue,
  usePortal,
  debouncingTime,
}: LocationTypeaheadProps) {
  const TypeAheadImpl = usePortal ? TypeaheadPortal : Typeahead;

  const [chosenItem, setChosenItem] =
    useState<FormattedGeolocationForDropdown>(null);
  const handleChange = (value) => {
    setChosenItem(value);
    // legacy - not used by newer
    setInputValue?.(value);
    onSelectAddress?.(value);
    shouldShowErrorMessage && setShouldShowErrorMessage?.(false);
  };

  const formattedOptions: FormattedGeolocationForDropdown[] = useMemo(() => {
    return data?.locationSuggestions?.map?.(formatGeolocationForDropdown) || [];
  }, [data]);

  return (
    <TypeAheadImpl
      passthruProps={{
        onInputChange: onQueryChanged,
        loadedOptions: formattedOptions,
        options: formattedOptions,
        shouldShowErrorMessage: shouldShowErrorMessage,
      }}
      onChange={handleChange}
      value={inputValue ?? chosenItem}
      debouncingTime={debouncingTime} // if debouncingTime is not passed. It will take default value.
    />
  );
}
